import { FC } from "react";
import clsx from "clsx";
import { Media, MediaLeft, MediaBody } from "@ht/components";
import dayjs from "dayjs";
import Linkify from 'react-linkify';
interface IProps {
    text: string;
    variant?: "mine" | "other";
    time?: Date;
    senderId: string;
    isSent: boolean;
    minTime: boolean;
    handledByAgent?: string;
}

const Message: FC<IProps> = ({ text, variant, time, minTime, isSent, senderId, handledByAgent }) => {
    const repliedByBot = (senderId == 'BOT' && <span className="text-red-400">bot</span>);
    const sentIcon = (isSent ? <span className="fa fa-check font-light"></span> : <span className="fa fa-clock-o"></span>);
    const minDate = () => {
        const getDate = () => {
            let result = dayjs(time).format('DD MMM YYYY');
            if (result == dayjs().format('DD MMM YYYY'))
                result = "Today";
            else if (dayjs().diff(dayjs(time), "day") == 1)
                result = "Yesterday";
            return result;
        }
        return (
            <div className="sticky z-10 top-0 h-7 px-5 flex items-center justify-center bg-gray-50">
                <div className="border-gray-200 border-b flex-1"></div>
                <div className="my-2 p-1 mx-5 text-center text-base">
                    {getDate()}
                </div>
                <div className="border-gray-200 border-b flex-1"></div>
            </div>
        )
    }
    const handledByAgentArea = () => {
        return (
            <div className="top-6 h-7 px-5 flex items-center justify-center bg-gray-50">
                <div className="border-gray-200 border-b flex-1"></div>
                <div className="my-2 p-1 mx-5 text-center text-base">
                    Handled by <span className="font-semibold">{handledByAgent}</span>
                </div>
                <div className="border-gray-200 border-b flex-1"></div>
            </div>
        )
    }

    return (
        <>
            {minTime && minDate()}
            {handledByAgent && handledByAgentArea()}
            <Media className={clsx("px-5 pb-[5px] pt-[5px]")} >
                <MediaLeft
                    className={clsx(
                        "relative w-[55px]",
                        variant === "other" && "order-2"
                    )}
                >
                </MediaLeft>
                <MediaBody
                    className={clsx(
                        "flex flex-col",
                        variant === "mine" && "items-end",
                        variant === "other"
                    )}
                >

                    <div className="max-w-[80%] mt-[5px] first:mt-0">
                        <div style={{ wordBreak: "break-word" }}
                            className={clsx(
                                "py-3 px-3 mb-0 inline-block rounded-lg text-md",
                                variant === "mine" && "bg-primary-100 text-gray-700",
                                variant === "other" && "bg-gray-200 text-gray-700"
                            )}
                        >
                            <Linkify>
                                {text}
                            </Linkify>
                        </div>
                        <p className={clsx("text-base m-1 font-normal text-gray-400",
                            variant === "mine" && "text-right",
                            variant === "other" && "text-left")}>{dayjs(time).format('HH:mm')} {repliedByBot} {sentIcon}</p>
                    </div>
                </MediaBody>
            </Media >
        </>
    );
};

export default Message;
